module.exports = __webpack_public_path__ + "img/Rows.27369780.svg";